import { Component, OnInit, OnDestroy } from '@angular/core';
import { Message } from 'primeng//api';
import { PeopleService } from 'src/app/services/people.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ness-merge-people-container',
  templateUrl: './merge-people-container.component.html'
})
export class MergePeopleContainerComponent implements OnInit, OnDestroy {
  disableAddPeopleButton: boolean = false;
  peopleMergeList: ServerModels.ENESS_PersonDTO[] = [];
  findPeopleValidationMessages: Message[] = [];
  selectedPeopleToMerge: ServerModels.ENESS_PersonDTO[] = [];
  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private peopleService: PeopleService) { }

  ngOnInit() {
    const mergePeopleIds = sessionStorage.getItem('mergePeople');
    if (mergePeopleIds != null) {
      this.peopleService.getPersonsByStringOfIdsForReturn(mergePeopleIds).pipe(takeUntil(this._unsubscribe$)).subscribe({
        next: (people: ServerModels.ENESS_PersonDTO[]) => {
          this.peopleMergeList = people;
          sessionStorage.removeItem('mergePeople');
        }
      })
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public updateSelectedPeople(peopleList: ServerModels.ENESS_PersonDTO[]): void {
    this.findPeopleValidationMessages = [];
    this.selectedPeopleToMerge = [...peopleList]
    this.disableAddPeopleButton = (this.selectedPeopleToMerge.length + this.peopleMergeList.length > 3);
    if (this.selectedPeopleToMerge.length > 3 || (this.selectedPeopleToMerge.length + this.peopleMergeList.length > 3)) {
      this.findPeopleValidationMessages.push({ severity: 'error', summary: 'Validation Message', detail: 'You may only merge up to three people at once.' });
    }
  }

  public addSelectedPeopleToMerge(): void {
    let jointArray = this.selectedPeopleToMerge.reduce((acc, curVal, idx) => {
      if (!acc[idx]) {
        acc.push(curVal);
      } else if (acc[idx].PersonID != curVal.PersonID) {
        acc.push(curVal);
      }
      return acc;
    }, [...this.peopleMergeList]);

    this.peopleMergeList = [...jointArray];
    this.peopleService.findPeopleResultSubj.next([]);
    this.selectedPeopleToMerge = [];
    this.findPeopleValidationMessages = [];
  }

  public personRemoved(person: string) {
    this.peopleMergeList = this.peopleMergeList.filter(x => x.PersonID != person);
    this.selectedPeopleToMerge = this.selectedPeopleToMerge.filter(x => x.PersonID != person);
  }
}
